import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {AuthenticatedBaseComponent} from '../../../authenticated-base.component';
import {TranslatePipe} from '@ngx-translate/core';
import {RouterLink} from '@angular/router';
import {TableComponent} from '../../../../components/table/table.component';

@Component({
  selector: 'app-authenticated-administration-diagnoses-index',
  templateUrl: './index.component.html',
  imports: [
    TableComponent,
    RouterLink,
    TranslatePipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IndexComponent extends AuthenticatedBaseComponent implements OnInit {
  public ngOnInit() {
    this.titleService.setTitle('authenticated.administration.diagnoses.index.title');
  }
}
